import React from "react";
import _ from "lodash";
import PopupWrapper from "../../../common/PopupWrapper";
import { formatMoneyWithCurrency } from "components/playground/home-dashboard-v1/ReportsHelper";
import AdvertiserAndBrandsSelector from "../custom-upr/AdvertiserAndBrandsSelector";

const PRICE_TYPE_NAME = {
  0: "Floor",
  1: "Target CPM",
  // LGO: 2, // not an option for brand price settings
};

class FirstLookPriceSectionPopover extends React.PureComponent {
  render() {
    const {
      settings,
      triggerElement,
      currency,
      networkId,
      place,
      onOpen,
      onClose,
    } = this.props;
    // inventory, device category, os, country...

    return (
      <PopupWrapper
        place={place}
        triggerType="click"
        hideArrow={false}
        triggerElement={triggerElement}
        onOpen={onOpen}
        onClose={onClose}
        popupElement={
          <div
            className="shadow border overflow-y-auto p-4"
            style={{ width: "600px", maxHeight: "600px" }}
          >
            <div>
              <div className="mt-2 font-semibold text-gray-900">
                Branded Price Settings ({(settings || []).length})
              </div>
              <div>
                {settings ? (
                  <div className="flex flex-col gap-3">
                    {settings.map((item, index) => {
                      let numOfAdvertisersAndBrands = 0;
                      if (
                        item.targeting &&
                        item.targeting.advertisersAndBrands
                      ) {
                        numOfAdvertisersAndBrands = _.filter(
                          item.targeting.advertisersAndBrands,
                          (a) => {
                            return a.advertiserId !== "0";
                          }
                        ).length;
                      }
                      return (
                        <div
                          className="border-t-2 border-gray-600 pt-3"
                          key={index}
                        >
                          <div
                            key={index}
                            className={`border divide-y flex flex-col p-2 ${
                              item.isSetForEverything ? "bg-blue-100" : ""
                            }`}
                          >
                            {item.isSetForEverything && (
                              <div className="pb-1">
                                <div className="text-sm font-semibold leading-tight text-gray-800">
                                  Is Set For Everything
                                </div>
                                <div className="text-blue-600">
                                  {item.isSetForEverything && "True"}
                                </div>
                              </div>
                            )}

                            {item.branded && (
                              <div className="pb-1">
                                <div
                                  className={`text-sm font-semibold leading-tight text-gray-800 ${
                                    item.isSetForEverything ? "mt-1" : ""
                                  }`}
                                >
                                  Branded
                                </div>
                                <div
                                  className={
                                    item.branded === "BLOCKED" && "text-red-600"
                                  }
                                >
                                  {item.branded}
                                </div>
                              </div>
                            )}

                            <div className="pb-1">
                              <div className="mt-1 text-sm font-semibold leading-tight text-gray-800">
                                Advertisers and Brands{" "}
                                <span>({numOfAdvertisersAndBrands})</span>
                              </div>
                              <div className="leading-tight">
                                {item.targeting &&
                                item.targeting.advertisersAndBrands ? (
                                  <div>
                                    <AdvertiserAndBrandsSelector
                                      networkId={networkId}
                                      targeting={
                                        item.targeting["advertisersAndBrands"]
                                      }
                                      isDisabled={true}
                                    ></AdvertiserAndBrandsSelector>
                                  </div>
                                ) : (
                                  "-"
                                )}
                              </div>
                            </div>

                            <div className="">
                              <div className="mt-1 text-sm font-semibold leading-tight text-gray-800">
                                Price
                              </div>
                              <div className="text-sm">
                                {PRICE_TYPE_NAME[item.priceType]}{" "}
                                {formatMoneyWithCurrency({
                                  currency: _.isEmpty(item.currency)
                                    ? currency
                                    : item.currency,
                                  value: item.price,
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  "-"
                )}
              </div>
            </div>
          </div>
        }
      ></PopupWrapper>
    );
  }
}

export default FirstLookPriceSectionPopover;
